// extracted by mini-css-extract-plugin
export default {"mbt":"Mbt_mbt__j2A4F"};